import { attachmentsApi } from './queries/attachments'
import { authApi } from './queries/auth'
import { cartApi } from './queries/cart'
import { claimRecordsApi } from './queries/claimRecords'
import { configApi } from './queries/config'
import { insurersApi } from './queries/insurers'
import { sessionsApi } from './queries/sessions'

export const middleware = [
  authApi.middleware,
  insurersApi.middleware,
  claimRecordsApi.middleware,
  sessionsApi.middleware,
  configApi.middleware,
  attachmentsApi.middleware,
  cartApi.middleware,
]
